import { render, staticRenderFns } from "./CommunicateFilter.vue?vue&type=template&id=5e1794d5&"
import script from "./CommunicateFilter.vue?vue&type=script&lang=js&"
export * from "./CommunicateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports